import { useEffect, useState } from 'react'
import { ApiTax } from '@vend/types'
import { useAppSelector } from '../../../../state/hooks'
import { selectSaleCustomer } from '../../../../state/slices/currentSale/currentSaleSlice'
import { customerTaxesStore } from '../../../../factories/database/customer-taxes-store'
import { TaxesStore } from '../../../../factories/database/taxes-store'

const taxesStore = new TaxesStore()

/**
 * Looks up the current sale customer's custom tax override from IDB.
 *
 * Returns the resolved `ApiTax`
 */
export const useCustomerTaxes = (): ApiTax | undefined => {
  const saleCustomer = useAppSelector(selectSaleCustomer)

  const [customerTax, setCustomerTax] = useState<ApiTax | undefined>(undefined)

  // Look up the customer's custom tax from IDB when the customer changes
  useEffect(() => {
    let cancelled = false

    if (!saleCustomer?.id) {
      setCustomerTax(undefined)
      return
    }

    customerTaxesStore
      .get(saleCustomer.id, true)
      .then((customerTaxRecord: { tax_id?: string | null } | undefined) => {
        if (cancelled) return
        if (!customerTaxRecord?.tax_id) {
          setCustomerTax(undefined)
          return
        }
        return taxesStore.get(customerTaxRecord.tax_id)
      })
      .then((tax: ApiTax | undefined) => {
        if (cancelled) return
        setCustomerTax(tax ?? undefined)
      })
      .catch(() => {
        if (!cancelled) setCustomerTax(undefined)
      })

    return () => {
      cancelled = true
    }
  }, [saleCustomer?.id])

  return customerTax
}
